import { createTRPCClient, httpBatchLink } from '@trpc/client';
import superjson from 'superjson';

import { isDesktop } from '@/const/version';
import type { EdgeRouter } from '@/server/routers/edge';
import { withBasePath } from '@/utils_cp/base-path';

import { fetchWithDesktopRemoteRPC } from './helpers/desktop-remote-rpc-fetch';

export const edgeClient = createTRPCClient<EdgeRouter>({
  links: [
    httpBatchLink({
      fetch: isDesktop
        ? (input, init) => fetchWithDesktopRemoteRPC(input as string, init)
        : undefined,
      headers: async () => {

        return {};
      },
      maxURLLength: 2083,
      transformer: superjson,
      url: withBasePath('/api/trpc/edge'),
    }),
  ],
});
